@use 'styles/functions/rem' as *;

.container {
    margin: rem(10px);
}

.horizontalGridContainer {
    display: grid;
    gap: 0.5rem;
    grid-template-columns: 1fr 1fr rem(150px);
}

.wrapper {
    gap: rem(5px);
    padding-top: rem(10px);
}
